<template>
  <div>
    <client-modal ref="client-modal" @close="onClose" @clientName="setClientNameOnTitle"/>
  </div>
</template>

<script>

import ClientModal from '@/components/modal/clientModal.vue'

export default {
  name: 'ClientsView',
  components: { ClientModal },
  data: () => ({
    clientNameHasBeenSet: false,
  }),
  mounted() {
    //Retrieve clientId from url and open modal
    const clientId = this.$route.params.clientId;
    if (clientId != null) {
      this.$refs['client-modal'].showModal(clientId);
    }
  },
  methods:{
    setClientNameOnTitle(name){
      if(this.clientNameHasBeenSet){
        return;
      }
      this.clientNameHasBeenSet = true;
      document.title = `${name.replace(/<[^>]*>?/gm, '')}` + " - " + document.title
    },
    onClose(){
      console.log('Closing client view window');
      window.close();
    }
  }

};
</script>

<style>


</style>
